import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const root = css`
  background-color: ${cssTheme.default.day.backgroundMinor};
  block-size: ${spacing(25)};
  border-radius: ${spacing(2)};
  padding: ${spacing(3)};
  position: relative;
  transition: background-color 0.2s ease-in;

  &:hover {
    background-color: ${cssTheme.default.day.controlMinor};
  }
`
export const row = css`
  flex-grow: 0;
`
export const radio = css`
  ${cssTheme.default.day.controlMinor.token}: ${cssTheme.default.day.background};
`
export const hovered = css`
  cursor: pointer;
`
export const checked = css`
  background-color: ${cssTheme.default.day.controlMinor};
`
export const date = css`
  margin-block-start: ${spacing(1)};
  color: ${cssTheme.colors.chrome[500]};
`
